import React from 'react';
import CampaignList from './CampaignList';

export default function NewLeadsTab(props) {
  return (
    <>
      {' '}
      <CampaignList />
    </>
  );
}
